import { render } from "./show-category-item.vue?vue&type=template&id=32587a7c&scoped=true&ts=true"
import script from "./show-category-item.vue?vue&type=script&lang=ts"
export * from "./show-category-item.vue?vue&type=script&lang=ts"

import "./show-category-item.vue?vue&type=style&index=0&id=32587a7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32587a7c"]])

export default __exports__